// extracted by mini-css-extract-plugin
export default {"handle":"P5viz_handle__332IQ"};